import {useSessionStorage} from '@aboutyou/storage';
import {COLORS, GenericIconName, HeaderButton} from '@aboutyou/ui-components';
import React from 'react';
import {useNotificationCenterOpenedStateManager} from '../useNotificationCenterOpenedStateManager';
import {useTrackNotificationCenterButton} from '../useTrackNotificationCenterButton';
import {Notification as NotificationType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/notification_center/v1/notifications.types';

export const NotificationCenterButton: React.FC<{
  notifications?: NotificationType[];
  onClick: VoidFunction;
  notificationBellRef: React.RefObject<HTMLDivElement>;
}> = ({notifications = [], onClick, notificationBellRef}) => {
  const [wasNotificationCenterOpened, setWasNotificationCenterOpened] =
    useSessionStorage({
      key: 'was_notification_center_opened',
      defaultValue: false,
    });
  const {open} = useNotificationCenterOpenedStateManager();
  const {featureImpressionRef, trackOnOpenNotificationCenter} =
    useTrackNotificationCenterButton();

  const handleOnClick = () => {
    onClick();
    open();
    setWasNotificationCenterOpened(true);
    trackOnOpenNotificationCenter();
  };

  const numberOfNotifications = getTotalNumberOfNotifications(
    notifications,
    wasNotificationCenterOpened,
  );

  return (
    <HeaderButton
      data-testid="HeaderNotificationButton"
      asset={GenericIconName.Bell}
      iconSize="S"
      badgeColor={COLORS.RedSale}
      onClick={handleOnClick}
      count={numberOfNotifications}
      badgeOffset={{
        right: 3,
        top: 3,
      }}
      showBadge={numberOfNotifications > 0}
      ref={featureImpressionRef}
      iconRef={notificationBellRef}
    />
  );
};

const getTotalNumberOfNotifications = (
  notifications: NotificationType[],
  wasNotificationCenterOpened?: boolean,
) => {
  if (wasNotificationCenterOpened) {
    return 0;
  }

  return notifications.length;
};
